import templateUrl from 'emun.salesrep/hardcode-manager/hardcode-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import HardcodePrompt from "emun.salesrep/hardcode-manager/hardcode-prompt"
import orderConfig from "emun.order/order.config";

class HardcodeListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.orderConfig = orderConfig;
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryRetailerVendors.json',
			autoLoad: true,
			hideLeftNav: true,
			pageSize: 24,
			filters: [
				{ groupBy: "SalesRepListName", title: "Rep Name" },
				{ groupBy: "VendorListLabel", title: "Vendor"}
			],
			sortOptions: {
				"RetailerId,VendorListLabel": "Customer: A to Z",
				"-RetailerId,VendorListLabel": "Customer: Z to A",
				"SalesRepListName": "Rep: A to Z",
				"-SalesRepListName": "Rep: Z to A",
				"VendorListLabel": "Vendor: A to Z",
				"-VendorListLabel": "Vendor: Z to A",
			},
			orderBy: "RetailerId,VendorListLabel"
		});
		if ($ctrl.retailerId) {
			$ctrl.query.filter("RetailerId", $ctrl.retailerId);
		}
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("hardcodeSaved", (e, args) => {
			$ctrl.query.load(true);
			$ctrl.query.filter("RetailerId",args);
		});
    }

	create() {
		const $ctrl = this;
		return HardcodePrompt({
			size: 'xl',
			retailerId: $ctrl.retailerId ? $ctrl.retailerId : undefined
		}).then(function(res) {
			$ctrl.query.load(true);
		});
	}

	edit(hardcode) {
		const $ctrl = this;
		return HardcodePrompt({ 
			size: 'xl',
			retailerId: hardcode.retailerId 
		})
	}

	delete(hardcode) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete this hard code?", "Delete Hard Code?")
			.result.then(function () {
				$ctrl.bus
					.send("DeleteRetailerVendor.json", hardcode)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let HardcodeList = {
	controller: HardcodeListController,
	bindings: {
		retailerId: '@'
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default HardcodeList;
